import { useEffect, useState } from "react";
import { FaSync } from "react-icons/fa"
import useShipmentSnackbar from "../Shared/useShipmentSnackbar";
import useFetchOrders from "../Shared/useFetchOrders";
import useFetchRefreshDates from "../Shared/useFetchRefreshShipping";

export const useRefreshOrder = () => {
  const shipmentSnackbar = useShipmentSnackbar()
  const { fetchOrders } = useFetchOrders()

  const fetchOrderRefresh = async ({ order, isAddDelay }) => {
    try {
      // Shipbob seems to have an 'eventually consistant' database, which means everything we send WON'T RETURN CORRECT INFO FOR SOME TIME 
      if (isAddDelay) {
        await new Promise(resolve => setTimeout(resolve, 1500))
      }

      const options = { 
        orderId: (order?.source === 'db' ? order?._id : undefined), 
        // TODO even though we specify this, fetchOrders limits the result by DB filters, not SB filters, so we'll get EVERY DB record back.
        //   Luckily this works for finalize because it orders by most recently changed, but this is a problem.
        shipbobOrderId: (order?.source === 'sb' ? order?.id : undefined),
        useCache: false,
        ...(order ? {} : { limit: 0 }) 
      }
      //console.log('order', order, 'options', options, '(order ? {} : { limit: 0 })', (order ? {} : { limit: 0 }))
      const orders = await fetchOrders(options)

      if (orders.error) {
        throw new Error(orders.error)
      }
      return orders
    } catch (e) {
      console.error(e)
      shipmentSnackbar.newMessage({ message: 'Error refreshing order(s)', severity: 'failure' })
      return { error: e }
    }
  }

  return fetchOrderRefresh
}

export default ({
  text = 'Refresh',
  order,
  onRefreshStart,
  onRefreshComplete
}) => {
  const refreshOrder = useRefreshOrder()
  const { fetchRefreshDates: fetchRefreshDatesHook } = useFetchRefreshDates()

  const [refreshDate, setRefreshDate] = useState()

  const onClick = async () => {
    if (onRefreshStart?.() === false) return
    const orders = await refreshOrder({ order })
    onRefreshComplete?.(orders)
  }

  const fetchRefreshDates = async () => {
    const refreshDate = await fetchRefreshDatesHook()
    setRefreshDate(refreshDate)
  }
  
  useEffect(() => {
    fetchRefreshDates()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (<>
    <FaSync title={text} onClick={onClick} style={{ cursor: 'pointer' }} />{refreshDate?.opportunityRefreshDate}
  </>)
}